"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/**
 * RadioField Component
 *
*/
var RadioField = /*#__PURE__*/function (_Component) {
  _inherits(RadioField, _Component);
  var _super = _createSuper(RadioField);
  function RadioField(props) {
    var _this;
    _classCallCheck(this, RadioField);
    _this = _super.call(this, props);
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.state = {
      loading: false
    };
    return _this;
  }
  _createClass(RadioField, [{
    key: "onChange",
    value: function onChange(value) {
      var callback = (0, _utils.getPreferredProp)(this.props, 'onChange');
      if ((0, _lodash.isFunction)(callback)) {
        callback(value);
      }
      if ((0, _lodash.isFunction)(this.props.onChange) && !(0, _lodash.isEqual)(this.props.onChange, (0, _utils.getPreferredProp)(this.props, 'onChange'))) {
        this.props.onChange(value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        options = _this$props.options,
        className = _this$props.className,
        labelClassName = _this$props.labelClassName,
        id = _this$props.id,
        style = _this$props.style,
        inline = _this$props.inline,
        label = _this$props.label,
        inlineLabel = _this$props.inlineLabel,
        postLabelContent = _this$props.postLabelContent,
        required = _this$props.required;
      var hasError = (0, _utils.getPreferredProp)(this.props, 'invalid') && (0, _utils.getPreferredProp)(this.props, 'touched');
      var containerClass = function containerClass() {
        return (0, _classnames["default"])({
          'ui-radio-field': true,
          'ui-radio-field--inline': inline,
          'ui-form-field': true,
          'ui-form-field--has-error': hasError,
          'ui-radio-field--has-error': hasError
        }, className);
      };
      var labelClass = function labelClass() {
        return (0, _classnames["default"])({
          'ui-form-field__label': true,
          'ui-form-field__label--left': inlineLabel,
          'ui-radio-field__label': true,
          'ui-form-field__label--required': required,
          'ui-form-field__label--roman-label': !(0, _lodash.isEmpty)(labelClassName) && labelClassName === 'ui-label-roman ui-label-roman--lowercase'
        });
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: containerClass(),
        style: style.container,
        "aria-labelledby": "label-".concat(id),
        role: "radiogroup"
      }, !(0, _lodash.isEmpty)(label) && /*#__PURE__*/_react["default"].createElement("div", {
        id: "label-".concat(id),
        className: labelClass(),
        style: style.label
      }, label), postLabelContent, (0, _lodash.map)(options, function (opt, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "ui-radio-field__item",
          key: index
        }, /*#__PURE__*/_react["default"].createElement("label", {
          htmlFor: "".concat(id, "-").concat(index)
        }, /*#__PURE__*/_react["default"].createElement("input", {
          id: "".concat(id, "-").concat(index),
          type: "radio",
          name: (0, _utils.getPreferredProp)(_this2.props, 'name'),
          checked: (0, _utils.getPreferredProp)(_this2.props, 'value') === opt.value,
          onChange: _this2.onChange,
          onBlur: (0, _utils.getPreferredProp)(_this2.props, 'onBlur'),
          onFocus: (0, _utils.getPreferredProp)(_this2.props, 'onFocus'),
          disabled: opt.disabled,
          style: style.input,
          value: opt.value
        }), /*#__PURE__*/_react["default"].createElement("span", {
          id: "".concat(opt.value, "-label")
        }, opt.label)));
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "ui-form-field__error",
        style: style.error
      }, (0, _utils.getPreferredProp)(this.props, 'error')));
    }
  }]);
  return RadioField;
}(_react.Component);
RadioField.propTypes = _objectSpread({
  /** id for reference */
  id: _propTypes["default"].string.isRequired,
  /** className for reference */
  className: _propTypes["default"].string,
  /** array of options consist of value and label */
  options: _propTypes["default"].array,
  /** Text of the label */
  label: _propTypes["default"].string,
  /** If true, Radio Buttons will be displayed inline */
  inline: _propTypes["default"].bool,
  /** If true, Radio Label will be displayed inline */
  inlineLabel: _propTypes["default"].bool,
  /** Content block that is placed between the label and the field */
  postLabelContent: _propTypes["default"].node,
  /** Is the field required */
  required: _propTypes["default"].bool,
  /** Override the inline-styles of the elements || **Not Recommended** */
  style: _propTypes["default"].shape({
    container: _propTypes["default"].object,
    label: _propTypes["default"].object,
    text: _propTypes["default"].object,
    error: _propTypes["default"].object
  })
}, _utils.fieldProps);
RadioField.defaultProps = {
  id: '',
  className: '',
  options: [],
  inlineLabel: false,
  label: '',
  labelClassName: '',
  postLabelContent: null,
  required: false,
  style: {
    container: {},
    label: {},
    input: {},
    error: {}
  },
  inline: false
};
var _default = exports["default"] = RadioField;